import { t } from '../../../../lang';
import './DetailStatus.scss';

const getDetailProps = (statusId, isDeposit) => {
	if (isDeposit) {
		return { label: t('Success_v2'), className: 'status--success' };
	}

	switch (statusId) {
		case 2:
			return { label: t('Success_v2'), className: 'status--success' };
		case 1:
		case 4:
		case 5:
		case 7:
		case 8:
		case 9:
			return { label: t('In progress'), className: 'status--progress' };
		case 3:
		case 6:
		case 10:
			return { label: t('Failed'), className: 'status--failed' };
		default:
			return { label: '', className: '' };
	}
};

const DetailStatus = ({ statusId, isDeposit }) => {
	const { label, className } = getDetailProps(statusId, isDeposit);

	return (
		<div className={`DetailStatus FormBlock`}>
			<p>{t('Status')}</p>
			<p className={className}>{label}</p>
		</div>
	);
};

export default DetailStatus;
